import React from "react";
import { AdapterSimulateModel } from "../../../../../domain/models/city-adapter-config";
import * as S from "../styles";

type Props = {
  simulation: AdapterSimulateModel | null;
  loading: boolean;
  onSimulate: () => void;
  disabled: boolean;
};

const SimulationPanel: React.FC<Props> = ({ simulation, loading, onSimulate, disabled }) => (
  <S.SectionCard>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
      <S.SectionTitle>🔍 Simulação</S.SectionTitle>
      <S.CreateButton type="button" onClick={onSimulate} disabled={disabled || loading} style={{ padding: "8px 16px" }}>
        {loading ? "Simulando..." : "Simular"}
      </S.CreateButton>
    </div>

    {disabled && (
      <p style={{ color: "#424242", fontSize: 12, fontFamily: "Poppins, sans-serif" }}>
        Preview não disponível — a simulação precisa de um payload de referência.
      </p>
    )}

    {simulation && (
      <S.SimulationGrid>
        <div>
          <p style={{ fontWeight: 600, fontSize: 12, marginBottom: 8, color: "#424242", fontFamily: "Poppins, sans-serif" }}>
            JSON Original
          </p>
          <S.JsonPreview>{JSON.stringify(simulation.original, null, 2)}</S.JsonPreview>
        </div>
        <div>
          <p style={{ fontWeight: 600, fontSize: 12, marginBottom: 8, color: "#4caf50", fontFamily: "Poppins, sans-serif" }}>
            JSON com Adapter
          </p>
          <S.JsonPreview>{JSON.stringify(simulation.transformado, null, 2)}</S.JsonPreview>
        </div>
      </S.SimulationGrid>
    )}
  </S.SectionCard>
);

export default SimulationPanel;
